module.exports = __webpack_public_path__ + "media/images/common/control_t-cd7cc33a043e32f4bc55214b08a1661a.gif";